import { useNavigate } from 'react-router';
import { SideMenuPage } from '@/features/taxreturn/menus/SideMenuPage';
import { DataTable, type DataTableColumn } from '@/kit/DataTable';
import { notifyError } from '@/core/notify/notify';
import { filingService } from '@/core/services/filing';
import type { CompanyPscRow } from '@/core/models/filing.models';
import { fetchedLabel } from './TaxreturnIntegrations';
import { guardClient, useLiveState, useOnInit, useSelectedClient } from './shared';
import './Integrations.scss';

const columns: DataTableColumn<CompanyPscRow>[] = [
  { id: 'name', header: 'Name', cell: (row) => row.name },
  { id: 'address', header: 'Address', headerClassName: 'w-200', cellClassName: 'w-200', cell: (row) => row.address },
  { id: 'notified', header: 'Notified on', cell: (row) => row.notified },
  { id: 'ceased', header: 'Ceased on', cell: (row) => row.ceased },
  { id: 'residence', header: 'Country of Residence', cell: (row) => row.residence },
  { id: 'nationality', header: 'Nationality', cell: (row) => row.nationality },
  {
    id: 'nature',
    header: 'Nature of Control',
    cell: (row) => (
      <ul className="control-list">
        {row.natures.map((nature, index) => (
          <li key={index}>{nature}</li>
        ))}
      </ul>
    ),
  },
];

/** Persons with significant control from Companies House (Angular TaxreturnIntegrationsPersonlistComponent). */
export function TaxreturnIntegrationsPersonlist() {
  const navigate = useNavigate();
  const client = useSelectedClient();
  const [s, set] = useLiveState<{ dataSource: CompanyPscRow[]; fetchedLabel: string }>({
    dataSource: [],
    fetchedLabel: '',
  });

  useOnInit(() => {
    if (!guardClient(client, navigate)) {
      return;
    }
    filingService.getPersonsWithSignificantControl(client.id).then(
      (result) => {
        set({ dataSource: result.items, fetchedLabel: fetchedLabel(result) });
        if (result.refreshError) {
          notifyError(`Showing the last fetched data. ${result.refreshError}`);
        }
      },
      (error) => notifyError(error),
    );
  });

  return (
    <SideMenuPage menu="integration" contentClassName="tr-integrations">
      <div className="content-body">
        <div className="content-header mb-0">
          <div className="content-header-left mb-1">
            <p className="subtitle">List of Person with Significant Control : {s.fetchedLabel}</p>
          </div>
        </div>
        <div className="mat-table-wrapper no-hover">
          <DataTable stickyHeader columns={columns} rows={s.dataSource} rowKey={(_, index) => index} />
        </div>
      </div>
    </SideMenuPage>
  );
}
